import React from "react";
import logo from "../Images/logo.png";

const CamaraTurismo = () => {
  return (
    <div className="bg-dark">
      <div className="container py-5 text-light">
        <h2 className="text-center mb-4 d-xl-none d-block">
          Cámara de Turismo de Bella Unión:
          <br /> <span className="fs-3">Impulsando el Destino y su Gente</span>
        </h2>
        <div className="row g-3 align-items-stretch justify-content-center">
          <div className="col-lg-3 col-md-5 col-sm-7 col-9 d-flex align-items-center">
            <img src={logo} alt="Camara de turismo de Bella Unión" className="img-fluid rounded-3" />
          </div>
          <div className="col-xl-6 d-flex align-items-center">
            <div>
              <h2 className="text-center mb-4 d-xl-block d-none">
                Cámara de Turismo de Bella Unión:
                <br /> <span className="fs-3">Impulsando el Destino y su Gente</span>
              </h2>
              <p className="text-center">
                La Cámara de Turismo de Bella Unión nace a fines de 2024 como una subcomisión del Centro
                Comercial e Industrial de Bella Unión, con el objetivo de promover y fortalecer el desarrollo
                turístico de la región.
              </p>
              <p className="text-center">
                Está integrada por empresas, emprendedores y profesionales del sector, y actúa como espacio de
                trabajo, representación y articulación ante instituciones públicas y privadas.
              </p>
              <p className="text-center">
                Desde la Cámara se impulsan acciones de promoción del destino, mejora de servicios,
                capacitación e innovación en experiencias turísticas.
              </p>
              <p className="text-center">
                Este sitio web cuenta con el aval de la Cámara de Turismo de Bella Unión, como herramienta
                oficial de difusión y promoción del destino.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CamaraTurismo;
